import { useEffect, useState } from "react";
import { EncabezadoSeccion, Reveal } from "./motion";

function calcular(fechaISO) {
  const diff = Math.max(0, new Date(fechaISO).getTime() - Date.now());
  return {
    dias: Math.floor(diff / 86400000),
    horas: Math.floor(diff / 3600000) % 24,
    minutos: Math.floor(diff / 60000) % 60,
    segundos: Math.floor(diff / 1000) % 60,
    terminado: diff <= 0,
  };
}

const UNIDADES = [
  { clave: "dias", etiqueta: "Días" },
  { clave: "horas", etiqueta: "Horas" },
  { clave: "minutos", etiqueta: "Minutos" },
  { clave: "segundos", etiqueta: "Segundos" },
];

// Cuenta regresiva compartida. Estructura de clases: {p}-cuenta, {p}-cuenta-unidad,
// {p}-cuenta-numero, {p}-cuenta-etiqueta, {p}-cuenta-finalizada.
export default function CuentaRegresiva({ datos, seccion, p = "we" }) {
  const fechaISO = datos.evento?.fechaISO;
  const [t, setT] = useState(() => calcular(fechaISO));

  useEffect(() => {
    const id = setInterval(() => setT(calcular(fechaISO)), 1000);
    return () => clearInterval(id);
  }, [fechaISO]);

  if (!fechaISO) return null;

  return (
    <section className={`${p}-seccion`} aria-label={seccion.titulo}>
      <div className={`${p}-seccion-interior`}>
        <EncabezadoSeccion p={p} etiqueta={seccion.etiqueta} titulo={seccion.titulo} testid={`${p}-titulo-cuenta`} />
        {t.terminado ? (
          <Reveal>
            <p className={`${p}-cuenta-finalizada`} data-testid={`${p}-cuenta-finalizada`}>
              {seccion.textoFinalizado || "¡Llegó el gran día!"}
            </p>
          </Reveal>
        ) : (
          <Reveal>
            <div className={`${p}-cuenta`} data-testid={`${p}-cuenta-regresiva`}>
              {UNIDADES.map((u) => (
                <div className={`${p}-cuenta-unidad`} key={u.clave}>
                  <p className={`${p}-cuenta-numero`}>{String(t[u.clave]).padStart(2, "0")}</p>
                  <p className={`${p}-cuenta-etiqueta`}>{u.etiqueta}</p>
                </div>
              ))}
            </div>
          </Reveal>
        )}
      </div>
    </section>
  );
}
